import { createFileRoute } from '@tanstack/react-router';
import ShadcnShowcase from '../components/ui/ShadcnShowcase';

export const Route = createFileRoute('/shadcn-showcase')({
  component: ShadcnShowcase,
});
